import React, { FC, Fragment } from 'react';
import { connect } from 'react-redux';
import { Dialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { IAppState } from '../../../state/reducers';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import JobList from '../../Shared/JobList/component';
import {
  openJobStatusReview,
  closeJobStatusReview,
  clearJobs,
  selectActiveUploads,
  selectNumberCurrentUploads,
  selectFailedUploads,
} from '../../../state/jobStatus';
import { VaultButton, FaIcon, ErrorIcon } from '../../Shared';
import { selectFailedLiveEvents } from '../../../state/liveEvents/jobsLiveEvents';

const Transition = React.forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Slide direction="up" ref={ref} {...props} />);

const VaultJobsButton: FC<IProps> = (props: IProps) => {
  const {
    isOpen,
    onOpen,
    onClose,
    onExited,
  } = props;

  const getJobsStatusButton = () => {
    const { failedUploads, numActiveUploads, failedLiveStreams } = props;
    const displayError = (failedUploads && failedUploads.length > 0) || (failedLiveStreams && failedLiveStreams.length > 0);
    if (displayError) {
      return (
        <VaultButton
          variant="jobsErrorButton"
          onClick={onOpen}
          data-auto="JobsErrorBtn"
        >
          <>
            <ErrorIcon />
          </>
          ERROR
        </VaultButton>
      );
    }
    switch (numActiveUploads) {
      case (0):
        return (
          <VaultButton
            variant="transparentOnBlack"
            onClick={onOpen}
            data-auto="JobsBtn"
          >
            Jobs
          </VaultButton>
        );
      case (1):
        return (
          <VaultButton
            variant="jobsButton"
            onClick={onOpen}
            data-auto="JobsBtn"
          >
            <>
              <FaIcon
                icon={faSpinner}
                spin
                $small
              />
            </>
            Job in Progress
          </VaultButton>
        );
      default:
        return (
          <VaultButton
            variant="jobsButton"
            onClick={onOpen}
            data-auto="JobsBtn"
          >
            <>
              <FaIcon
                icon={faSpinner}
                spin
                $small
              />
            </>
            Jobs in Progress
          </VaultButton>
        );
    }
  };

  return (
    <>
      {getJobsStatusButton()}
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullScreen
        TransitionComponent={Transition}
      >
        <JobList />
      </Dialog>
    </>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.jobStatus.isOpen,
  activeUploads: selectActiveUploads(state),
  numActiveUploads: selectNumberCurrentUploads(state),
  failedUploads: selectFailedUploads(state),
  failedLiveStreams: selectFailedLiveEvents(state),
});

const mapDispatchToProps: IDispatchProps = {
  onOpen: openJobStatusReview,
  onClose: closeJobStatusReview,
  onExited: clearJobs,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VaultJobsButton);
